var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ls-image",attrs:{"test-id":"image"},on:{"click":_vm.openImage}},[_c('img',{attrs:{"src":_vm.src}})])}
var staticRenderFns = []

export { render, staticRenderFns }